// src/components/Products.jsx
import React, { useState, useEffect } from 'react';
import '../App.css';
import { useNavigate } from 'react-router-dom';
import { Button } from 'reactstrap';
import MyStorage from './util/storage';
import { Oval as Loader } from 'react-loader-spinner';
import Api from './api/api'; // create getProducts, deleteProduct functions
import { ToastContainer } from 'react-toastify';
import showToast from './util/toast';

const Products = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    // redirect if not logged in
    if (!MyStorage.isLogin()) {
      navigate('/admin/login', { replace: true });
      return;
    }
    // load products if logged in
    loadData();
  }, []); // ✅ still always called, but logic inside is conditional

  const loadData = () => {
    setLoader(true);
    Api.getProducts(
      (response) => {
        setLoader(false);
        setProducts(response);
      },
      () => {
        setLoader(false);
        showToast('error', 'Failed to load products!');
      }
    );
  };

  const editProduct = (item) => {
    navigate('/admin/add-product', { state: { model: item } });
  };

  const deleteProduct = (item) => {
    if (!window.confirm('Are you sure you want to delete this product?')) return;

    const temp = products.filter(p => p.id !== item.id);
    setProducts(temp);

    Api.deleteProduct(item, ()=>{
      //
    })
  };

  return (
    <div className='main'>
      <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
        <div style={{ color: 'blue' }}>Products</div>
      </div>

      <div style={{ width: '100%', display: 'flex', flexDirection: 'column', padding: 0 }}>
        <div style={{ padding: 30, display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'scroll' }}>
          <Button
            className='btn-block btn-dark'
            style={{ marginTop: 10, fontSize: 18, fontWeight: 'bold', backgroundColor: 'green', borderWidth: 0, height: 40, width: 300, alignSelf: 'center' }}
            onClick={() => navigate('/admin/add-product', { state: { model: null } })}>
            Add Product
          </Button>

          <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' }}>
            {products.map((item, index) => (
              <div key={index} style={{ width: '100%', backgroundColor: 'white', marginTop: 10, padding: 0, marginRight: 10, display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                <div style={{ display: 'flex', backgroundColor: '#f2f2f2', padding: 10 }}>
                  <div>
                    {item.images && item.images.length > 0 ? (
                      <img src={item.images[0]} alt='' style={{ width: 120, height: 120, objectFit: 'cover', marginRight: 15 }} />
                    ) : (
                      <div style={{ width: 120, height: 120, backgroundColor: '#fff', marginRight: 15, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'gray' }}>No Image</div>
                    )}
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                    <div style={{ fontSize: 16 }}>{item.title}</div>

                    <div style={{ display: 'flex', marginTop: 10 }}>
                      <Button
                        style={{ fontSize: 16, fontWeight: 'bold', backgroundColor: 'orange', borderWidth: 0, height: 40, width: 100, marginRight: 10 }}
                        onClick={() => editProduct(item)}>
                        Edit
                      </Button>
                      <Button
                        style={{ fontSize: 16, fontWeight: 'bold', backgroundColor: 'red', borderWidth: 0, height: 40, width: 100 }}
                        onClick={() => deleteProduct(item)}>
                        Delete
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {loader && (
        <div style={{ position: 'absolute', display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', height: '80%', width: '80%' }}>
          <Loader type="ThreeDots" color="white" height={70} width={70} visible={true} />
        </div>
      )}

      <ToastContainer />
    </div>
  );
};

export default Products;
